import React, { createContext, useContext, useMemo } from 'react';
import { useHttpClientCore } from '@/shared/infra/http/HttpClientContext';
import { ApiGeneratedReportRepository } from '../repositories/ApiGeneratedReportRepository';

export const GeneratedReportDIContext = createContext<ApiGeneratedReportRepository | undefined>(
  undefined
);

export const GeneratedReportDIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const core = useHttpClientCore();
  const repository = useMemo(() => new ApiGeneratedReportRepository(core), [core]);
  return (
    <GeneratedReportDIContext.Provider value={repository}>
      {children}
    </GeneratedReportDIContext.Provider>
  );
};

export const useGeneratedReports = (): ApiGeneratedReportRepository => {
  const repository = useContext(GeneratedReportDIContext);
  if (!repository)
    throw new Error('useGeneratedReports must be used inside GeneratedReportDIProvider');
  return repository;
};
